import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com';
const IS_PRODUCTION = import.meta.env.MODE === 'production';

let initialized = false;

export function initPostHog() {
  // Only initialize in production environment
  if (!IS_PRODUCTION || initialized || !POSTHOG_KEY) {
    return;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    // Disable automatic pageview - we handle manually for SPA
    capture_pageview: false,
    // Capture page leave events
    capture_pageleave: true,
    // Enable autocapture for clicks, form submissions, etc.
    autocapture: true,
    // Session recording configuration
    session_recording: {
      // Mask all text inputs for privacy
      maskAllInputs: true,
      // Mask all text content (optional, more aggressive privacy)
      maskTextSelector: '[data-ph-mask]',
    },
    // Respect Do Not Track browser setting
    respect_dnt: true,
  });

  initialized = true;
}

export function identifyUser(userId: string, traits?: Record<string, unknown>) {
  if (!IS_PRODUCTION || !POSTHOG_KEY) return;
  
  posthog.identify(userId, traits);
}

export function resetUser() {
  if (!IS_PRODUCTION || !POSTHOG_KEY) return;
  
  posthog.reset();
}

export function captureEvent(event: string, properties?: Record<string, unknown>) {
  if (!IS_PRODUCTION || !POSTHOG_KEY) return;
  
  posthog.capture(event, properties);
}

export function capturePageview(path?: string) {
  if (!IS_PRODUCTION || !POSTHOG_KEY) return;
  
  posthog.capture('$pageview', {
    $current_url: path || window.location.href,
  });
}

export { posthog };
